import { makeAutoObservable } from "mobx";
import PaginatedEndpoint from "~/util/PaginatedEndpoint";
import notifStore from "./notifications";
import { OrganizationalUnitId, OrganizationalUnitInfo } from "~/document";

export type { OrganizationalUnitId, OrganizationalUnitInfo };

export class OrganizationalUnitStore {
  f = new PaginatedEndpoint<OrganizationalUnitInfo>("organizational-units", notifStore);

  constructor() {
    makeAutoObservable(this);
  }
}

const organizationalUnitStore = new OrganizationalUnitStore();

export default organizationalUnitStore;
